import { render, staticRenderFns } from "./ServiceRequestChalanList.vue?vue&type=template&id=d59ec3fc&"
import script from "./ServiceRequestChalanList.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestChalanList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequestChalanList.vue?vue&type=style&index=0&id=d59ec3fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports